// app/src/index.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Configure Amplify with the exported configuration
Amplify.configure(awsExports);

const root = ReactDOM.createRoot(document.getElementById("root"));

// No need for AuthProvider wrapper with Amplify
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);